var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-gray"},[_vm._v(_vm._s(_vm._f("uppercase")(_vm.message.type))+" - ")]),_c('span',[_vm._v(_vm._s(_vm.message.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }